<!-- Seção de template do componente AvisosCarousel -->
<template>
  <!-- Container principal do carrossel de avisos -->
  <div class="carousel-container-avisos" v-if="this.contemAvisos">
    <!-- Título do carrossel, exibido apenas quando não está em modo de manutenção -->
    <div class="form-title-primary">
      <span class="form-title-primary" id="titulo-avisos">AVISOS</span>
    </div>

    <div class="carousel-avisos-container">
    <!-- Botão para navegar para o slide anterior -->
    <button @click="prevSlide" class="carousel-control-avisos prev-avisos" id="carousel-control-avisos" :disabled="currentIndex === 0"
      :class="{ disabled: currentIndex === 0 }" aria-label="Slide anterior">
      <!-- Ícone de seta para a esquerda -->
      <img class="setas-navegacao" src="@/assets/icons/seta-left.svg" alt="Seta para a esquerda" />
    </button>

    
    <!-- Botão para navegar para o próximo slide -->
    <button @click="nextSlide" class="carousel-control-avisos next-avisos" id="carousel-control-avisos" :disabled="isAtEnd"
      :class="{ disabled: isAtEnd }" aria-label="Próximo slide">
      <!-- Ícone de seta para a direita -->
      <img class="setas-navegacao" src="@/assets/icons/seta-right.svg" alt="Seta para a direita" />
    </button>
    </div>

    <!-- Container do conteúdo do carrossel -->
    <div class="carousel-avisos">
      <!-- Trilha do carrossel que se move para mostrar diferentes slides -->
      <div class="carousel-track" :style="{ transform: `translateX(-${currentIndex * 100}%)` }">

        <!-- Container de cada slide individual -->
        <div class="carousel-slide-avisos" v-for="(slide, slideIndex) in groupedItems" :key="slideIndex">

          <!-- Item individual do carrossel (aviso) -->
          <button class="carousel-item-avisos" v-for="(item, index) in slide" :key="index"
            @click="showAviso(item.objeto)">
            <div class="card-avisos">
              <p class="card-avisos-text">
                <!-- Data do aviso -->
                <strong class="date">{{ item.date }} - </strong>
                <strong class="content-text">{{ item.title }} </strong>
                <!-- Conteúdo do aviso truncado -->
                <span class="content-text"><span
                    v-html="truncateText(item.content, isSmallDevice ? 105 : 180)" /></span>
                <!-- Link "Leia mais" -->
                <a class="read-more" @click="showAviso(item.objeto)">Leia mais...</a>
              </p>
            </div>
          </button>
        </div>
      </div>
    </div>

    <Dialog :visible.sync="displayAviso" modal="true" :showHeader="false" v-if="avisoAtual && avisoAtual.titulo" style="backdrop-filter: blur(5px);">
      <div class="header-container">
        <!-- Título do modal -->
        <h1 class="titulo-header">{{avisoAtual.titulo}}</h1>
        <!-- Botão para fechar o modal -->
        <button @click="hideAviso()" type="button" class="btn-cancelar">
          <!-- Ícone personalizado de fechar localizado na pasta assets -->
          <img src="../../assets/icons/icon-close.svg" alt="Fechar" class="icon-close" />
        </button>
      </div>

      <div class="scrolable-dialog" style="max-width: 1000px;">
        <div class="row">
          <div v-if="avisoAtual.tipo == 'T'" v-html="avisoAtual.mensagem" />
          <label v-if="avisoAtual.tipo == 'Q'"><b>Assunto:</b></label>
          <div v-if="avisoAtual.tipo == 'Q'" v-html="avisoAtual.avisoAssunto.assunto" />
          <hr v-if="avisoAtual.tipo == 'Q'" />
          <label v-if="avisoAtual.tipo == 'Q'"><b>Pergunta:</b></label>
          <div v-if="avisoAtual.tipo == 'Q'" v-html="avisoAtual.avisoItem.pergunta" />
          <hr v-if="avisoAtual.tipo == 'Q'" />
          <label v-if="avisoAtual.tipo == 'Q'"><b>Resposta:</b></label>
          <div v-if="avisoAtual.tipo == 'Q'" v-html="avisoAtual.avisoItem.resposta" />
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import DnsClienteService from "@/services/nfse/dns.cliente.service"; // Importa o serviço de DNS para cliente relacionado a NFSe
import LoginService from "@/services/acesso/login.service";
// Definição do componente
export default {
  // Dados do componente
  data() {
    return {
      displayAviso: false,
      avisoAtual: null,
      contemAvisos: false,
      avisos: [],
      currentIndex: 0, // Índice do slide atual
      items: [],
      isSmallDevice: false, // Flag para detecção de dispositivos pequenos
    };
  },
  // Propriedades computadas
  computed: {
    // Agrupa os itens em slides com base no tamanho do dispositivo

    groupedItems() {
      const itemsPerSlide = this.isSmallDevice ? 1 : 4;
      const groups = [];
      for (let i = 0; i < this.items.length; i += itemsPerSlide) {
        groups.push(this.items.slice(i, i + itemsPerSlide));
      }
      return groups;
    },
    // Verifica se o carrossel está no último slide
    isAtEnd() {
      return this.currentIndex >= this.groupedItems.length - 1;
    },
  },
  // Métodos do componente
  methods: {
    hideAviso(){
      this.displayAviso = false;
    },
    showAviso(aviso){
      this.avisoAtual = aviso;
      this.displayAviso = true;
    },
    montarAvisos() {
      let retorno = [];
      if (this.avisos && this.avisos.length > 0) {
        this.contemAvisos = true;
        this.avisos.forEach(function (aviso) {
          retorno.push(
            {
              date: aviso.dataFormatada,
              title: aviso.titulo,
              content: aviso.mensagem,
              objeto: aviso
            }
          );
        });
      }
      return retorno;
    },
    // Avança para o próximo slide
    nextSlide() {
      if (this.currentIndex < this.groupedItems.length - 1) {
        this.currentIndex++;
      }
    },
    // Retorna para o slide anterior
    prevSlide() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    },
    // Trunca o texto para o comprimento especificado
    truncateText(text, maxLength) {
      if (text.length <= maxLength) return text;
      return text.slice(0, maxLength) + '...';
    },
    // Navega para o link do aviso
    goToAviso(link) {
      window.location.href = link;
    },
    // Lida com o redimensionamento da janela
    handleResize() {
      this.isSmallDevice = window.innerWidth <= 1280;
      this.currentIndex = 0;
    },
  },
  // Hooks do ciclo de vida
  mounted() {
    this.avisos = [];
    setTimeout(async () => {
      let host = window.location.hostname;
      let dnsCliente = await DnsClienteService.get(host);                           // Busca os dados do cliente DNS usando o hostname

      // Verifica se os dados do cliente DNS estão disponíveis
      if (
        dnsCliente &&
        dnsCliente.data &&
        dnsCliente.data.idCliente
      ) {
        let idCliente = dnsCliente.data.idCliente;
        LoginService.findAllAvisos(idCliente).then((res) => {
          this.avisos = res.data;
          this.items = this.montarAvisos();
        })
      }
    }, 250);
    // Chama handleResize quando o componente é montado
    this.handleResize();
    // Adiciona um listener para o evento de redimensionamento da janela
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    // Remove o listener de redimensionamento quando o componente é destruído
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<!-- Importa estilos adicionais -->
<style src="@/assets/css/avisosCarousel.css"></style>
